import { render, staticRenderFns } from "./InfoArea.vue?vue&type=template&id=16bd91b0&scoped=true&"
import script from "./InfoArea.vue?vue&type=script&lang=js&"
export * from "./InfoArea.vue?vue&type=script&lang=js&"
import style0 from "./InfoArea.vue?vue&type=style&index=0&id=16bd91b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd91b0",
  null
  
)

export default component.exports